<template>
  <div class="article-detail">
    <like v-if="!isMobile"></like>
    <Side></Side>
    <div class="article-list-content">
      <div class="article-header">
        <h3 class="title">{{articleDetail.SHORT_TITLE || articleDetail.TITLE}}</h3>
        <span class="article-main-list-item-date">{{articleDetail.PUBLISH_TIME && articleDetail.PUBLISH_TIME.substring(0, 10)}}</span>
        <p class="curr-location">當前位置：<a class="to-index" href="./index.html">首頁</a> > <a class="to-index" href="./index.html#/article-list?type=all">新聞</a> > 正文</p>
      </div>
      <div class="article-detail-main" id="article-content">
      </div>
    </div>
  </div>
</template>

<script>
import Side from '@/components/Side.vue'
import { getUrlParam } from '../utils/utils'
import { GET_ARTICLE_DETAIL } from '../store/config'
import Like from '../components/Like.vue'

export default {
  data () {
    return {
      articleDetail: {}
    }
  },
  created () {
    window.scrollTo(0, 0)
    const id = getUrlParam('id')
    this.$store.dispatch(GET_ARTICLE_DETAIL, id).then((res) => {
      this.articleDetail = res
      document.getElementById('article-content').innerHTML = this.articleDetail.CONTENT
    })
  },
  components: {
    Side,
    Like
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/base.scss";
  @import "@/assets/scss/article.scss";
</style>
